import { render, staticRenderFns } from "./PaginaNoEncontrada.vue?vue&type=template&id=b8afb88c&scoped=true"
import script from "./PaginaNoEncontrada.vue?vue&type=script&setup=true&lang=js"
export * from "./PaginaNoEncontrada.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PaginaNoEncontrada.vue?vue&type=style&index=0&id=b8afb88c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8afb88c",
  null
  
)

export default component.exports